/* tslint:disable */

/**
 */
export class SVGChart {
    x?: number;
    y?: number;
    textX?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/svgchart.ts